module.exports = __webpack_public_path__ + "media/images/page/a_ic-fd6a7c2488c342ff30b47d07642a50c2.svg";